/**
 * Реэкспорт dataLayer
 */
export default (window && window.dataLayer) || []
